var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpenSolid16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder-open-solid-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1C0.671573 1 0 1.67157 0 2.5V10.2335C0 10.7376 0.661599 10.9249 0.925829 10.4955L3.41427 6.45181C3.77827 5.86031 4.42307 5.5 5.11759 5.5H12.5C12.7761 5.5 13 5.27614 13 5V4.5C13 3.67157 12.3284 3 11.5 3H7.5L6.45 1.6C6.16672 1.22229 5.72214 1 5.25 1H1.5ZM5.83819 7C5.3173 7 4.8337 7.27023 4.56071 7.71385L1 13.5C0.572551 14.1412 1.03218 15 1.80278 15H11.5729C12.1411 15 12.6605 14.679 12.9146 14.1708L15.4146 9.17082C15.9133 8.17347 15.188 7 14.0729 7H5.83819Z",
    fill: "#7B868C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenSolid16);
export default __webpack_public_path__ + "static/media/folder_open_solid_16.d621c9fe63f1fcc7a3dd739aa4a6eded.svg";
export { ForwardRef as ReactComponent };